import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/')({
  // Component is lazy loaded from index.lazy.tsx
});
